import Login from '@shared/features/login/Login';
import { Auth0LoginButton } from '../Auth0/Auth0LoginButton';

const ChromeLogin = () => {
  return (
    <Login
      authBaseUrl={import.meta.env.VITE_API_BASE_URL}
      displayLogo={false}
      appName="Gmail"
    >
      <Auth0LoginButton />
    </Login>
  );
};

export default ChromeLogin;
